import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { GatewayStore } from '@store';
import { GatewayUpdateApi } from '@vi-iot/client/apis/gateway-update/gateway-update.api';
import { GatewayFirmwareUpdateStatus } from '@vi-iot/client/index';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  skip,
  switchMap,
  tap,
  timeout,
} from 'rxjs/operators';
import { GatewayFirmwareUpdateActions } from './gateway-firmware-update.actions';

@Injectable({ providedIn: 'root' })
export class GatewayFirmwareUpdateEffects {
  updateFirmwareProcessStart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(
        GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessStart
      ),
      switchMap((action) =>
        this.api.startUpdateFirmwareProcess(action.installationId, action.gatewaySerial).pipe(
          map(() =>
            GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessSuccess()
          ),
          catchError((err) =>
            of(
              GatewayFirmwareUpdateActions.GatewayFirmwareUpdateTriggerActions.installationProcessError(
                err
              )
            )
          )
        )
      )
    );
  });

  updateInProgress$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GatewayFirmwareUpdateActions.updateInProgress),
      switchMap(() =>
        this.gatewayStore.getGatewayFirmwareUpdateStatus().pipe(
          // The maximum time we can to wait for execution of endpoint
          timeout(600000),
          skip(1),
          distinctUntilChanged(),
          tap((updatedStatus) =>
            this.store.dispatch(GatewayFirmwareUpdateActions.setStatus({ updatedStatus }))
          ),
          filter(
            (updatedStatus) =>
              updatedStatus !== GatewayFirmwareUpdateStatus.DOWNLOADING &&
              updatedStatus !== GatewayFirmwareUpdateStatus.REBOOTING
          ),
          map((updatedStatus) => GatewayFirmwareUpdateActions.setStatus({ updatedStatus }))
        )
      ),
      catchError(() => {
        return of(
          GatewayFirmwareUpdateActions.setStatus({
            updatedStatus: GatewayFirmwareUpdateStatus.ERROR,
          })
        );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private api: GatewayUpdateApi,
    private gatewayStore: GatewayStore,
    private store: Store
  ) {}
}
